import GetRoomsRequestModelBase from '../_generated/modelBases/get-rooms-request-model-base';

export default class GetRoomsRequestModel extends GetRoomsRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
